import { PrimaryButton } from "../../../../../common/Buttons";
import ButtonTooltip from "./ButtonTooltip";

const BaseButton = ({ children, component, disabled, onClick, tooltip }) => (
  <ButtonTooltip title={tooltip}>
    <PrimaryButton component={component} disabled={disabled} onClick={onClick}>
      {children}
    </PrimaryButton>
  </ButtonTooltip>
);

export default BaseButton;
